import './InlineIconWrapper.css'
import React from 'react'

const InlineIconWrapper = ({
  color,
  style,
  children,
  iconComponent: IconComponent,
  ...props
}) => (
  <React.Fragment>
    <IconComponent
      className="InlineIconWrapper-svg"
      style={{
        width: '1em',
        height: '1em',
        color: 'inherit',
        ...style,
      }}
    />
    <span className="InlineIconWrapper-span">{children}</span>
  </React.Fragment>
)

export default InlineIconWrapper



// WEBPACK FOOTER //
// ./src/components/InlineIconWrapper.js